var checkout_auto_renewal_toggle = (function ($) {

    var $checkout;
    var $wrapper;
    var $toggle;

    var _init = function () {
        $checkout = $('.woocommerce-checkout');

        if ($checkout.length > 0) {
            _init_auto_renewal_toggle();
        }
    };

    var _init_auto_renewal_toggle = function () {
        $wrapper = $checkout.find('.toggle-wrapper');
        $toggle = $wrapper.find('.toggle');

        $toggle.on('click', function () {
            _toggle_auto_renewal();
        });
    };

    var _toggle_auto_renewal = function () {
        var $checkbox = $toggle.siblings('#enable_auto_renewal');
        var toggling_to = !$checkbox.prop('checked');

        $checkbox.prop('checked', toggling_to);
        $wrapper.find('.toggle-label').text(toggling_to ? 'ON' : 'OFF');
    };

    $(document).ready(_init);

    return {};

})(jQuery);

module.exports = checkout_auto_renewal_toggle;